export default __webpack_public_path__ + "static/important-loans-bf0ae7f033621127d9e3db61702ba135.jpg";